import { render } from "./AddProductToTOModal.vue?vue&type=template&id=3fd18882&ts=true"
import script from "./AddProductToTOModal.vue?vue&type=script&lang=ts"
export * from "./AddProductToTOModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__